<template>
  <div class="className" />
</template>

<script>
import echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
require('echarts/theme/macarons')
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    name: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ name, waterCount, examinerCount } = {}) {
      this.chart.setOption({
        // 去除背景色
        backgroundColor: 'transparent', // 设置背景色为透明
        grid: {
          left: '40px', // 去掉左边距
          right: '0%', // 去掉右边距
          top: '10px', // 根据需要设置顶部边距
          bottom: '20px', // 根据需要设置底部边距
        },
        // tooltip: {
        //   // 触发类型，默认数据触发，可选为：'item' | 'axis'
        //   trigger: 'axis',
        // },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: name,
          axisLabel: {
            color: '#ffffff', // 设置 x 轴文字颜色为橙色
          },
          // axisLine: {
          //   lineStyle: {
          //     color: '#ff0000', // 这里设置为红色
          //   },
          // },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'red', // 设置 X 轴网格线颜色为红色
              type: 'solid', // 设置网格线类型，可以是 'solid', 'dashed', 或 'dotted'
            },
          }, // 去除网格线
          // splitArea: { show: true }, //保留网格区域
        },
        yAxis: {
          type: 'value',
          // splitLine: { show: false }, //去除网格线
          splitArea: {
            show: false, // 去除网格的背景色
          },
          axisLine: {
            show: false, // 不显示 y 轴线
          },
          axisLabel: {
            color: '#ffffff', // 设置 Y 轴文字颜色为橙色
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#263e5e', // 设置 Y 轴网格线颜色为蓝色
              // type: 'dashed', // 设置网格线类型，可以是 'solid', 'dashed', 或 'dotted'
            },
          },
        },
        series: [
          {
            data: examinerCount,
            type: 'bar',
            name: '验收员',
            itemStyle: {
              color: '#f3ce49', // 设置所有柱条的颜色为橙色
            },
          },
          {
            data: waterCount,
            type: 'bar',
            name: '水工',
            itemStyle: {
              color: '#456ec3', // 设置所有柱条的颜色为橙色
            },
          },
        ],
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
  },
}
</script>
<style less scoped>
.className {
  width: 100%;
  height: 20vh;
  /* height: 470px; */
}
</style>
